import https from 'https'

export default ({ app }) => {
  app.$axios.defaults.timeout = 5000
  app.$axios.defaults.httpsAgent = new https.Agent({
    rejectUnauthorized: false,
    keepAlive: true
  })
}
